import CircularProgress, { type CircularProgressProps } from "@mui/material/CircularProgress";
import { useLoadingStore } from "store/loadingStore";

// API requests may already show the blue application loader. Never stack a local
// indicator on top of it; background-only work still gets a blue local indicator.
export default function FutureBoardProgress(props: CircularProgressProps) {
  const globalLoading = useLoadingStore(state => state.isLoading);
  if (globalLoading) return null;
  return <CircularProgress color="info" {...props} />;
}
